var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutgoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M20 0H0V20H20V0Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0866 1.66748L11.3322 8.421",
    stroke: "#4990E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3848 1.66666H18.0866V7.36841",
    stroke: "#4990E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87645 16.1235C0.140894 12.388 -0.187806 6.92485 3.06912 2.76633L3.28412 2.5L6.77107 5.98695L6.65831 6.14683C5.07047 8.47367 5.64053 11.0194 7.31054 12.6894C8.96148 14.3403 11.4681 14.9163 13.7732 13.3953L14.0131 13.2289L17.5 16.7158L17.18 16.9724L17.1246 17.0153C12.98 20.1818 7.57942 19.8265 3.87645 16.1235Z",
    fill: "url(#paint0_linear_4_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_24",
    x1: 25.8333,
    y1: 10.8333,
    x2: 9.16664,
    y2: -5.83333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B90E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoing);
export default __webpack_public_path__ + "static/media/Outgoing.daa98ef13b7e1869ea1e58936f9661e5.svg";
export { ForwardRef as ReactComponent };